
import { defineComponent } from "vue";

export default defineComponent({
    name: "Heart",
    props: {
        color: {
            type: String,
            default: "#333333",
        },
    },
});
